import { render, staticRenderFns } from "./AgencyFeesBonusElement.vue?vue&type=template&id=6899115a&scoped=true"
import script from "./AgencyFeesBonusElement.vue?vue&type=script&setup=true&lang=js"
export * from "./AgencyFeesBonusElement.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AgencyFeesBonusElement.vue?vue&type=style&index=0&id=6899115a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6899115a",
  null
  
)

export default component.exports